<template>
</template>

<script>
  import {clearToken} from '@/lib/common.js'

  export default {
    name: 'Logout',
    created () {
      console.log('logout')
      clearToken()
      this.$router.replace('/login')
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Logout.vue